module.exports = {
  //Gis
  backendPath: "https://gis.uznature.uz",
  WS_URL: "wss://gis.uznature.uz",
}

// module.exports = {
//   //Begzod aka
//   backendPath: "http://192.168.31.21:8001",
//   WS_URL: "ws://192.168.31.21:8001",
// };

// module.exports = {
//   //Xamza
//   backendPath: "http://192.168.31.27:8001",
//   WS_URL: "ws://192.168.31.27:8886",
// };
